import axios from 'axios';

const getSingleAccessEnabled = async ({
  orgId,
  onboardingPortalId,
}: {
  orgId: string;
  onboardingPortalId: string;
}): Promise<boolean> => {
  const { data } = await axios.get<boolean>(
    `/onboarding_portal_association/${orgId}/onboarding-id/${onboardingPortalId}/single-access`,
  );

  return data;
};

export default getSingleAccessEnabled;
